"use client";

import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Facebook, Instagram, Twitter } from "lucide-react";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex gap-6">
        <div className="h-5 w-16 bg-accent-light/20 animate-pulse rounded-md" />
        <div className="h-5 w-16 bg-accent-light/20 animate-pulse rounded-md" />
        <div className="h-5 w-16 bg-accent-light/20 animate-pulse rounded-md" />
      </div>;
  }
  return <nav className="flex flex-wrap gap-6">
      {menuItems.map(item => <Link key={item.id} to={item.href || "#"} className="text-sm text-accent-light/90 hover:text-accent-light transition-all duration-[var(--duration-fast)] hover:translate-y-[-2px]">
          {item.label}
        </Link>)}
    </nav>;
}
export default function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer id="footer" className="relative bg-accent text-foreground-accent">
      {}
      <div className="absolute top-0 left-0 right-0 h-16 overflow-hidden">
        <svg viewBox="0 0 1440 100" fill="none" xmlns="http://www.w3.org/2000/svg" className="absolute top-0 w-full h-full" preserveAspectRatio="none">
          <path d="M0 50C240 20 480 80 720 50C960 20 1200 80 1440 50V100H0V50Z" fill="currentColor" className="text-background" />
        </svg>
      </div>

      <div className="container mx-auto px-6 pt-24 pb-8">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
          {}
          <div className="flex-shrink-0">
            <Link to="/">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549040/img/ecoluxmaya_logo.png" alt="EcoLuxMaya" className="h-7 transition-all duration-[var(--duration-medium)] hover:scale-[1.03]" />
            </Link>
          </div>

          {}
          <div className="flex flex-col gap-6 items-start md:items-end">
            {}
            <MenuProvider menu_id="30">
              <FooterMenuConsumer />
            </MenuProvider>

            {}
            <div className="flex gap-4">
              <Link to="https://facebook.com/ecoluxmaya" newTab className="group flex items-center justify-center size-10 rounded-full bg-accent-light/10 text-accent-light hover:bg-accent-light hover:text-accent transition-all duration-[var(--duration-medium)] hover:translate-y-[-4px] hover:brightness-110" aria-label="Facebook">
                <Facebook className="size-5" />
              </Link>
              <Link to="https://instagram.com/ecoluxmaya" newTab className="group flex items-center justify-center size-10 rounded-full bg-accent-light/10 text-accent-light hover:bg-accent-light hover:text-accent transition-all duration-[var(--duration-medium)] hover:translate-y-[-4px] hover:brightness-110" aria-label="Instagram">
                <Instagram className="size-5" />
              </Link>
              <Link to="https://twitter.com/ecoluxmaya" newTab className="group flex items-center justify-center size-10 rounded-full bg-accent-light/10 text-accent-light hover:bg-accent-light hover:text-accent transition-all duration-[var(--duration-medium)] hover:translate-y-[-4px] hover:brightness-110" aria-label="Twitter">
                <Twitter className="size-5" />
              </Link>
            </div>
          </div>
        </div>

        {}
        <div className="mt-12 pt-6 border-t border-accent-light/20">
          <p className="text-xs text-accent-light/70 text-center md:text-left font-sans">
            © {currentYear} EcoLuxMaya. All rights reserved. Playa del Carmen, Riviera Maya, Mexico
          </p>
        </div>
      </div>
    </footer>;
}